export * from './common';
export * from './mobile';
export * from './tablet';
export * from './desktop';

// Nuevos estilos para la página Support con diseño hero + formulario

export const supportPageStyles = {
  container: {
    width: '100vw',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa', // Fondo general claro
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  }
};

export const heroSectionStyles = {
  background: {
    background: '#183B56', // Azul marino principal
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
    py: { xs: 6, md: 8 },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `linear-gradient(135deg, #183B56 0%, #1e4060 100%)`,
      zIndex: 1
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-10%',
      right: '-10%',
      width: '40%',
      height: '120%',
      background: 'rgba(255, 255, 255, 0.03)',
      borderRadius: '50%',
      transform: 'rotate(-15deg)',
      zIndex: 2
    }
  },
  content: {
    position: 'relative',
    zIndex: 3,
    maxWidth: '800px',
    mx: 'auto',
    textAlign: 'center',
    px: { xs: 3, md: 4 }
  },
  title: {
    fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' },
    fontWeight: 700,
    mb: 3,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif',
    lineHeight: 1.2
  },
  subtitle: {
    fontSize: { xs: '1rem', md: '1.125rem' },
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: '600px',
    mx: 'auto',
    lineHeight: 1.6
  }
};

export const contentSectionStyles = {
  container: {
    backgroundColor: 'white',
    py: { xs: 4, md: 6 },
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: { xs: '90%', md: '70%' },
      height: '2px',
      background: 'linear-gradient(90deg, transparent 0%, #183B56 50%, transparent 100%)',
      opacity: 0.1
    }
  },
  wrapper: {
    maxWidth: 900,
    mx: 'auto',
    px: { xs: 3, md: 4 }
  }
};

export const helpSectionStyles = {
  container: {
    mb: 5,
    p: 4,
    backgroundColor: '#f8f9fa',
    borderRadius: 3,
    border: '1px solid #e9ecef'
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#183B56',
    mb: 3,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  listItem: {
    py: 0.75,
    px: 0,
    '&:not(:last-child)': {
      borderBottom: '1px solid #e9ecef'
    }
  },
  listText: {
    color: '#183B56',
    fontWeight: 500,
    fontSize: '1rem'
  },
  checkIcon: {
    color: '#EE752F',
    fontSize: '1.25rem'
  }
};

export const contactFormStyles = {
  container: {
    backgroundColor: 'white',
    p: 4,
    borderRadius: 3,
    boxShadow: '0 4px 20px rgba(24, 59, 86, 0.08)',
    border: '1px solid #e9ecef',
    mb: 5
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 600,
    color: '#183B56',
    mb: 2,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  description: {
    color: '#5A7184',
    mb: 4,
    fontSize: '1rem',
    lineHeight: 1.6
  },
  fieldContainer: {
    mb: 3
  },
  fieldLabel: {
    color: '#5A7184',
    fontWeight: 500,
    mb: 1,
    display: 'block',
    fontSize: '0.875rem'
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#f8f9fa',
      borderRadius: 2,
      '& fieldset': {
        borderColor: '#e9ecef'
      },
      '&:hover fieldset': {
        borderColor: '#183B56'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#183B56',
        borderWidth: 2
      }
    },
    '& .MuiInputBase-input': {
      color: '#183B56',
      fontSize: '1rem',
      fontFamily: 'Hanken Grotesk, Arial, sans-serif'
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#5A7184',
      opacity: 0.7
    }
  },
  submitButton: {
    backgroundColor: '#EE752F',
    color: 'white',
    py: 1.5,
    px: 4,
    borderRadius: 2,
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
    fontFamily: 'Hanken Grotesk, Arial, sans-serif',
    '&:hover': {
      backgroundColor: '#d86628',
      transform: 'translateY(-1px)',
      boxShadow: '0 6px 20px rgba(238, 117, 47, 0.3)'
    },
    '&:active': {
      transform: 'translateY(0)'
    },
    transition: 'all 0.2s ease-in-out'
  }
};

export const contactOptionsSectionStyles = {
  container: {
    mb: 5
  },
  grid: {
    spacing: 4
  },
  card: {
    textAlign: 'center',
    p: 4,
    backgroundColor: '#f8f9fa',
    borderRadius: 3,
    border: '1px solid #e9ecef',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(24, 59, 86, 0.1)',
      borderColor: '#183B56'
    }
  },
  icon: {
    width: 48,
    height: 48,
    mb: 2,
    color: '#EE752F'
  },
  emailIcon: {
    width: '48px',
    height: '48px',
    marginBottom: '16px',
    borderRadius: '8px',
    overflow: 'hidden'
  },
  phoneIcon: {
    width: '48px',
    height: '48px',
    marginBottom: '16px',
    borderRadius: '8px',
    overflow: 'hidden'
  },
  whatsappIcon: {
    width: '48px',
    height: '48px',
    marginBottom: '16px',
    borderRadius: '8px',
    overflow: 'hidden'
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#183B56',
    mb: 1,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  description: {
    color: '#5A7184',
    fontSize: '0.9rem',
    mb: 2,
    lineHeight: 1.5
  },
  contactInfo: {
    color: '#183B56',
    fontWeight: 500,
    fontSize: '1rem',
    textDecoration: 'none',
    '&:hover': {
      color: '#EE752F',
      textDecoration: 'underline'
    }
  },
  supportCenterLink: {
    color: '#EE752F',
    fontWeight: 600,
    textDecoration: 'none',
    fontSize: '1rem',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
};

export const faqSectionStyles = {
  container: {
    mb: 5
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 600,
    color: '#183B56',
    mb: 4,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  accordion: {
    mb: 2,
    borderRadius: 2,
    border: '1px solid #e9ecef',
    '&:before': {
      display: 'none'
    },
    '&.Mui-expanded': {
      boxShadow: '0 4px 15px rgba(24, 59, 86, 0.1)'
    }
  },
  accordionSummary: {
    backgroundColor: '#f8f9fa',
    borderRadius: '8px 8px 0 0',
    '&.Mui-expanded': {
      backgroundColor: '#183B56',
      color: 'white',
      '& .MuiAccordionSummary-expandIconWrapper': {
        color: 'white'
      }
    }
  },
  questionText: {
    fontWeight: 600,
    fontSize: '1rem',
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  answerText: {
    color: '#5A7184',
    lineHeight: 1.6,
    fontSize: '0.95rem'
  }
};

export const legalSectionStyles = {
  container: {
    textAlign: 'center',
    py: 4,
    borderTop: '1px solid #e9ecef',
    mt: 5
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#183B56',
    mb: 3,
    fontFamily: 'Hanken Grotesk, Arial, sans-serif'
  },
  linksContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 4,
    flexWrap: 'wrap',
    mb: 3
  },
  link: {
    color: '#5A7184',
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: 500,
    '&:hover': {
      color: '#EE752F',
      textDecoration: 'underline'
    }
  },
  versionText: {
    color: '#5A7184',
    fontSize: '0.875rem',
    fontStyle: 'italic'
  }
};

// Exportación por defecto para compatibilidad
export const supportContainerStyles = supportPageStyles.container; 